import axios from '@configs/axios'

export const getBalanceFeeAPI = async(id, data) => {
  const response = await axios.get(`/service_account/fees/${id}?payout_id=${data}`, data)
  return response?.data
}